import { GENERAL_ACTION } from "../actions/types";

const INITIAL_STATE = {
  error: null,
  success: null,
  headerConfig: {
    logoUrl: "#",
    phoneNumber: "03 9876 5412",
    termConditionLink: "#",
    policyLink: "#"
  }
};

const showError = (state, action) => {
  return { ...state, error: action.payload.error };
};

const clearError = (state, action) => {
  return { ...state, error: null };
};

const showSuccess = (state, action) => {
  return { ...state, success: action.payload.success };
};

const clearSuccess = (state, action) => {
  return { ...state, success: null };
};

const headerConfig = (state, action) => {
  return { ...state, headerConfig: action.payload.headerConfig };
};

export const generalReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GENERAL_ACTION.SHOW_ERROR:
      return showError(state, action);

    case GENERAL_ACTION.CLEAR_ERROR:
      return clearError(state, action);

    case GENERAL_ACTION.SHOW_SUCCESS:
      return showSuccess(state, action);

    case GENERAL_ACTION.CLEAR_SUCCESS:
      return clearSuccess(state, action);

    case GENERAL_ACTION.UPDATE_HEADER_CONFIG:
      return headerConfig(state, action);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Layout/reducers/generalReducer.js